import { createPinia } from "pinia";

// A singleton pinia instance so stores can be safely used outside Vue components
// (e.g. in router guards / axios interceptors).
const pinia = createPinia();

export default pinia;
